import { render, staticRenderFns } from "./OrderPhotoGalleryPhotoReplacement.vue?vue&type=template&id=59c8a2b1&"
import script from "./OrderPhotoGalleryPhotoReplacement.vue?vue&type=script&lang=js&"
export * from "./OrderPhotoGalleryPhotoReplacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports